import { CancellationReason, cancellationReasonContent } from '@acorn-portal/shared/src/pages/cancellation/types';

/**
 * Get cancellation reason field options
 * @param reasons - Array of cancellation reason values to include
 * @returns Array of options with label and value
 */
export const getCancellationReasonOptions = (reasons: CancellationReason[] = Object.values(CancellationReason)) => {
	return reasons.map((reason) => ({
		label: cancellationReasonContent[reason].label,
		value: reason,
	}));
};
